import { __decorate } from "tslib";
//NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
//SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ServiceDetailViewModel } from "@/store/models/service/ViewService";
import ServiceModule from "@/store/modules/service.module";
let ViewService = /** @class */ (() => {
    let ViewService = class ViewService extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            //DATA
            this.title = "ViewService";
            this.ctaButtons = [
                {
                    routeName: "Products",
                },
            ];
            this.items = [
                {
                    text: "Services",
                },
                {
                    text: "Service View",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedService = new ServiceDetailViewModel();
        }
        cancelService() {
            this.$router.push({ name: "Services" });
        }
        //CRUD
        editService(viewId) {
            this.$router.push({ name: "ServiceUpdate", params: { id: viewId } });
        }
        //LIFECYCLE
        created() {
            var viewId = Guid.parse(this.$route.params.id);
            ServiceModule.GetServiceDetailById(viewId).then((response) => {
                this.pageIsLoading = false;
                this.selectedService = new ServiceDetailViewModel();
                this.selectedService = {
                    id: response.viewService.id,
                    name: response.viewService.name,
                    latestVersion: response.viewService.latestVersion,
                    description: response.viewService.description,
                    license: response.viewService.license,
                    price: response.viewService.price,
                    url: response.viewService.url,
                    status: response.viewService.status,
                    userLimits: response.viewService.userLimits,
                };
            });
        }
    };
    ViewService = __decorate([
        Component({
            name: "ViewService",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], ViewService);
    return ViewService;
})();
export default ViewService;
